/**
 * @fileoverview gRPC-Web generated client stub for proto.services
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as proto_services_user_service_pb from '../../proto/services/user_service_pb';


export class UserServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreateUserByAdmin = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/CreateUserByAdmin',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.CreateUserByAdminRequest,
    proto_services_user_service_pb.CreateUserByAdminResponse,
    (request: proto_services_user_service_pb.CreateUserByAdminRequest) => {
      return request.serializeBinary();
    },
    proto_services_user_service_pb.CreateUserByAdminResponse.deserializeBinary
  );

  createUserByAdmin(
    request: proto_services_user_service_pb.CreateUserByAdminRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_user_service_pb.CreateUserByAdminResponse>;

  createUserByAdmin(
    request: proto_services_user_service_pb.CreateUserByAdminRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.CreateUserByAdminResponse) => void): grpcWeb.ClientReadableStream<proto_services_user_service_pb.CreateUserByAdminResponse>;

  createUserByAdmin(
    request: proto_services_user_service_pb.CreateUserByAdminRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.CreateUserByAdminResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/CreateUserByAdmin',
        request,
        metadata || {},
        this.methodDescriptorCreateUserByAdmin,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/CreateUserByAdmin',
    request,
    metadata || {},
    this.methodDescriptorCreateUserByAdmin);
  }

  methodDescriptorCreateUser = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/CreateUser',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.CreateUserRequest,
    proto_services_user_service_pb.CreateUserResponse,
    (request: proto_services_user_service_pb.CreateUserRequest) => {
      return request.serializeBinary();
    },
    proto_services_user_service_pb.CreateUserResponse.deserializeBinary
  );

  createUser(
    request: proto_services_user_service_pb.CreateUserRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_user_service_pb.CreateUserResponse>;

  createUser(
    request: proto_services_user_service_pb.CreateUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.CreateUserResponse) => void): grpcWeb.ClientReadableStream<proto_services_user_service_pb.CreateUserResponse>;

  createUser(
    request: proto_services_user_service_pb.CreateUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.CreateUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/CreateUser',
        request,
        metadata || {},
        this.methodDescriptorCreateUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/CreateUser',
    request,
    metadata || {},
    this.methodDescriptorCreateUser);
  }

  methodDescriptorGetUserById = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/GetUserById',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.GetUserByIdRequest,
    proto_services_user_service_pb.GetUserByIdResponse,
    (request: proto_services_user_service_pb.GetUserByIdRequest) => {
      return request.serializeBinary();
    },
    proto_services_user_service_pb.GetUserByIdResponse.deserializeBinary
  );

  getUserById(
    request: proto_services_user_service_pb.GetUserByIdRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_user_service_pb.GetUserByIdResponse>;

  getUserById(
    request: proto_services_user_service_pb.GetUserByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.GetUserByIdResponse) => void): grpcWeb.ClientReadableStream<proto_services_user_service_pb.GetUserByIdResponse>;

  getUserById(
    request: proto_services_user_service_pb.GetUserByIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.GetUserByIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/GetUserById',
        request,
        metadata || {},
        this.methodDescriptorGetUserById,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/GetUserById',
    request,
    metadata || {},
    this.methodDescriptorGetUserById);
  }

  methodDescriptorGetManagedUsersPaging = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/GetManagedUsersPaging',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.GetManagedUsersPagingRequest,
    proto_services_user_service_pb.GetManagedUsersPagingResponse,
    (request: proto_services_user_service_pb.GetManagedUsersPagingRequest) => {
      return request.serializeBinary();
    },
    proto_services_user_service_pb.GetManagedUsersPagingResponse.deserializeBinary
  );

  getManagedUsersPaging(
    request: proto_services_user_service_pb.GetManagedUsersPagingRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_user_service_pb.GetManagedUsersPagingResponse>;

  getManagedUsersPaging(
    request: proto_services_user_service_pb.GetManagedUsersPagingRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.GetManagedUsersPagingResponse) => void): grpcWeb.ClientReadableStream<proto_services_user_service_pb.GetManagedUsersPagingResponse>;

  getManagedUsersPaging(
    request: proto_services_user_service_pb.GetManagedUsersPagingRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.GetManagedUsersPagingResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/GetManagedUsersPaging',
        request,
        metadata || {},
        this.methodDescriptorGetManagedUsersPaging,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/GetManagedUsersPaging',
    request,
    metadata || {},
    this.methodDescriptorGetManagedUsersPaging);
  }

  methodDescriptorPatchUser = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/PatchUser',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.PatchUserRequest,
    proto_services_user_service_pb.PatchUserResponse,
    (request: proto_services_user_service_pb.PatchUserRequest) => {
      return request.serializeBinary();
    },
    proto_services_user_service_pb.PatchUserResponse.deserializeBinary
  );

  patchUser(
    request: proto_services_user_service_pb.PatchUserRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_user_service_pb.PatchUserResponse>;

  patchUser(
    request: proto_services_user_service_pb.PatchUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.PatchUserResponse) => void): grpcWeb.ClientReadableStream<proto_services_user_service_pb.PatchUserResponse>;

  patchUser(
    request: proto_services_user_service_pb.PatchUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.PatchUserResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/PatchUser',
        request,
        metadata || {},
        this.methodDescriptorPatchUser,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/PatchUser',
    request,
    metadata || {},
    this.methodDescriptorPatchUser);
  }

  methodDescriptorPutUserRoles = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/PutUserRoles',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.PutUserRolesRequest,
    proto_services_user_service_pb.PutUserRolesResponse,
    (request: proto_services_user_service_pb.PutUserRolesRequest) => {
      return request.serializeBinary();
    },
    proto_services_user_service_pb.PutUserRolesResponse.deserializeBinary
  );

  putUserRoles(
    request: proto_services_user_service_pb.PutUserRolesRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_user_service_pb.PutUserRolesResponse>;

  putUserRoles(
    request: proto_services_user_service_pb.PutUserRolesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.PutUserRolesResponse) => void): grpcWeb.ClientReadableStream<proto_services_user_service_pb.PutUserRolesResponse>;

  putUserRoles(
    request: proto_services_user_service_pb.PutUserRolesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.PutUserRolesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/PutUserRoles',
        request,
        metadata || {},
        this.methodDescriptorPutUserRoles,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/PutUserRoles',
    request,
    metadata || {},
    this.methodDescriptorPutUserRoles);
  }

  methodDescriptorPutUserStatus = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/PutUserStatus',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.PutUserStatusRequest,
    proto_services_user_service_pb.PutUserStatusResponse,
    (request: proto_services_user_service_pb.PutUserStatusRequest) => {
      return request.serializeBinary();
    },
    proto_services_user_service_pb.PutUserStatusResponse.deserializeBinary
  );

  putUserStatus(
    request: proto_services_user_service_pb.PutUserStatusRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_user_service_pb.PutUserStatusResponse>;

  putUserStatus(
    request: proto_services_user_service_pb.PutUserStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.PutUserStatusResponse) => void): grpcWeb.ClientReadableStream<proto_services_user_service_pb.PutUserStatusResponse>;

  putUserStatus(
    request: proto_services_user_service_pb.PutUserStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.PutUserStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/PutUserStatus',
        request,
        metadata || {},
        this.methodDescriptorPutUserStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/PutUserStatus',
    request,
    metadata || {},
    this.methodDescriptorPutUserStatus);
  }

  methodDescriptorCreateFeedback = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/CreateFeedback',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.CreateFeedbackRequest,
    proto_services_user_service_pb.CreateFeedbackResponse,
    (request: proto_services_user_service_pb.CreateFeedbackRequest) => {
      return request.serializeBinary();
    },
    proto_services_user_service_pb.CreateFeedbackResponse.deserializeBinary
  );

  createFeedback(
    request: proto_services_user_service_pb.CreateFeedbackRequest,
    metadata: grpcWeb.Metadata | null): Promise<proto_services_user_service_pb.CreateFeedbackResponse>;

  createFeedback(
    request: proto_services_user_service_pb.CreateFeedbackRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.CreateFeedbackResponse) => void): grpcWeb.ClientReadableStream<proto_services_user_service_pb.CreateFeedbackResponse>;

  createFeedback(
    request: proto_services_user_service_pb.CreateFeedbackRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: proto_services_user_service_pb.CreateFeedbackResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/CreateFeedback',
        request,
        metadata || {},
        this.methodDescriptorCreateFeedback,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/CreateFeedback',
    request,
    metadata || {},
    this.methodDescriptorCreateFeedback);
  }

  methodDescriptorUnLinkIDP = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/UnLinkIDP',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.UnLinkIDPRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_user_service_pb.UnLinkIDPRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  unLinkIDP(
    request: proto_services_user_service_pb.UnLinkIDPRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  unLinkIDP(
    request: proto_services_user_service_pb.UnLinkIDPRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  unLinkIDP(
    request: proto_services_user_service_pb.UnLinkIDPRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/UnLinkIDP',
        request,
        metadata || {},
        this.methodDescriptorUnLinkIDP,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/UnLinkIDP',
    request,
    metadata || {},
    this.methodDescriptorUnLinkIDP);
  }

  methodDescriptorLinkIDP = new grpcWeb.MethodDescriptor(
    '/proto.services.UserService/LinkIDP',
    grpcWeb.MethodType.UNARY,
    proto_services_user_service_pb.LinkIDPRequest,
    google_protobuf_empty_pb.Empty,
    (request: proto_services_user_service_pb.LinkIDPRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  linkIDP(
    request: proto_services_user_service_pb.LinkIDPRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  linkIDP(
    request: proto_services_user_service_pb.LinkIDPRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  linkIDP(
    request: proto_services_user_service_pb.LinkIDPRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/proto.services.UserService/LinkIDP',
        request,
        metadata || {},
        this.methodDescriptorLinkIDP,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/proto.services.UserService/LinkIDP',
    request,
    metadata || {},
    this.methodDescriptorLinkIDP);
  }

}

